import Protected from "@/pages/protected";
import { Outlet, type RouteObject } from "react-router-dom";
import SimulatorRoutes from "../tools/dialer/simulator";

/**
 * The simulator owns the viewport for the same reason as the canvas editor: the graph,
 * controls and trace are one workspace, not content inside the CRM page shell.
 *
 * Keeping the established `/outils/campagnes/.../simulateur` paths under this pathless
 * authenticated shell preserves bookmarks and back navigation while removing the main
 * menu and SFLike page chrome only for simulator screens.
 */
const DialerSimulatorStandaloneRoute: RouteObject = {
    path: "outils/campagnes",
    element: (
        <Protected allowed={user => Boolean(user.can_open_dialer)}>
            <Outlet />
        </Protected>
    ),
    children: SimulatorRoutes
};

export default DialerSimulatorStandaloneRoute;
